import React, { useMemo } from 'react';
import { TableColumn } from '@silverfort/sf-components';
import ExposureToggleColumn from './ExposureToggleColumn';
import ExposureNameColumn from './ExposureNameColumn';
import ExposureDescriptionColumn from './ExposureDescriptionColumn';
import ExposureCategoryColumn from './ExposureCategoryColumn';
import { ExposureConfig, StaticExposureCustomConfig } from '../types';

interface ExposureColumnDefinition extends TableColumn<ExposureConfig> {
    extractValue?: (row: ExposureConfig) => string | string[];
}

const useGetColumns = (
    onToggleExposure: (id: string, isActive: boolean) => void,
    onRowClick: (row: ExposureConfig) => void
) => {
    return useMemo(() => {
        const relevantColumns: ExposureColumnDefinition[] = [
            {
                columnKey: 'isActive',
                title: '',
                render: (row) => {
                    return (
                        row.isStatic && (
                            <ExposureToggleColumn id={row.id} isActive={row.isActive} onToggle={onToggleExposure} />
                        )
                    );
                },
                columnClassName: 'min-w-[48px] max-w-[48px]'
            },
            {
                columnKey: 'name',
                title: 'Exposure',
                render: (row) => (
                    <div className="cursor-pointer" onClick={() => onRowClick(row)}>
                        <ExposureNameColumn
                            name={row.displayName}
                            showIcon={
                                !!Object.keys((row as StaticExposureCustomConfig)?.customizableFields ?? {}).length
                            }
                        />
                    </div>
                ),
                extractValue: (row) => row.name,
                columnClassName: 'w-64 min-w-64 max-w-64'
            },
            {
                columnKey: 'description',
                title: 'Info',
                render: (row) => (
                    <div className="cursor-pointer w-full" onClick={() => onRowClick(row)}>
                        <ExposureDescriptionColumn description={row.description} />
                    </div>
                ),
                extractValue: (row) => row.description,
                columnClassName: 'flex-1 min-w-0 w-full'
            },
            {
                columnKey: 'category',
                title: 'Category',
                render: (row) => (
                    <div className="cursor-pointer" onClick={() => onRowClick(row)}>
                        <ExposureCategoryColumn category={row.category} />
                    </div>
                ),
                extractValue: (row) => row.category,
                columnClassName: 'w-50 min-w-50 max-w-50'
            }
        ];
        return relevantColumns;
    }, [onToggleExposure, onRowClick]);
};

export default useGetColumns;
